import { getCloudinaryUrl } from "@swiggy-private/js-utils";

export const GENERATE_BILL_CONSTANTS = {
    TITLE: "Done dining? generating this bill ends your order",
    DESCRIPTION: "Includes everything you ordered—online or through waiter",
    IMAGE_ALT: "Generate Bill",
    ICON_SIZE: 102,
    PRIMARY_BUTTON_TEXT: "Generate bill & end order",
};

export const IMAGES = {
    BILL_PAYMENT: getCloudinaryUrl("portal/static-assets/images/dineout/qr/Pay_Bill.png") || "",
};

export const STYLED_CONSTANTS = {
    BUTTON_CONTAINER_PADDING_BOTTOM: "28px",
    DESCRIPTION_CONTAINER_WIDTH: "330px",
};
